import tableAppManualProviders from './tableAppManualProviders';

export default {
  title: 'Manual V.T. Tokens',
  attributeName: 'manualVirtualTikets',
  getURL: 'appId/appManualProvider',
  createURL: 'appId/appManualProvider',
  updateURL: 'appId/appManualProvider',
  removeURL: 'appId/appManualProvider',
  idAttribute: 'providerId',
  sessionParams: ['appId'],
  noArea: true,
  loadFromFile: 'appId/appManualProviderFromFile',
  loadFromFileHelp: 'To load tokens from file.',
  fileExtensionType: ['.csv', '.txt'],
  importMonitoringChanel: 'appManualProviderFromFile-appId',
  importMonitoringSessionParams: ['appId'],
  importMonitoringTitle: 'Import tokens process',
  exportAction: 'appId/appManualProfiederExport',
  exportHelp: 'Export the token list',
  exportName: 'ManualProviderTokens.xlsx',
  tableConfig: tableAppManualProviders,
  autoUpdate: true,
  updateValuesAfterUpdate: ['used'],
};
